export enum ToiletStatus {
  UNKNOWNTOILETSTATUS = 'UNKNOWN_TOILET_STATUS',
  RUNNING = 'RUNNING',
  IN_MAINTENANCE = 'IN_MAINTENANCE',
  IN_PREPARING = 'PREPARING'
}
